import React from "react";
import loaderImg from "../../assets/webimage/renewable-energy.gif"

const PageSpinner: React.FC = () => (
	<div className={"fullscreen__spinner__wrapper"}>
		<img src={loaderImg} alt="loading"  height={'30%'}/>
	</div>
);

export default PageSpinner;
